import { useContext, useMemo } from 'react';
import { useStatusRenderer } from '../useStatus';
import { useDateFormat } from '../useDateFormate';
import eyeIcon from "../../../assets/image/eye.png"
import { useNavigate } from 'react-router-dom';
import invoiceIcon from "../../../assets/image/invoiceIcon.png"
import edit from "../../../assets/image/edit2.png"
import ApproveButton from '../../../assets/image/ApproveButton';
import RejectButton from '../../../assets/image/RejectButton';
import { ADMIN_MANAGER_ID, PURCHASE_CONTRACT_APPROVE_ID, SUPER_ADMIN_ID, VENDOR_APPROVE, VENDOR_MANAGER_PENDING, VENDOR_REJECT, VENDOR_VP_PENDING, VENDORID, VP_ID } from '../../constant';
import { ModalContext } from '../../Context';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ApproveModal from '../../../components/modal/ApproveModal';
import Alert from '../../../components/modal/Alert';
import RejectionModal from '../../../components/modal/RejectionModal';
import { FULLY_PAID_MESSAGE, PENDING_DETAILS_MESSAGE } from '../globalErrorMessage';
import { END_DATE, PURCHASE_CONTRACT, START_DATE, VENDOR_NAME } from './TableHeader';

// Custom hook for defining FeedsColumns
export const useFeedsColumnContracts = (handlerPurchaseContractList, pageNumber, pageSize, globalSearch) => {
  const user = JSON.parse(localStorage.getItem("userData"));
  const modalContext = useContext(ModalContext);
  const { handleModalData } = modalContext;
  const navigate = useNavigate();

  const handlerPurchaseView = (id) => {
    navigate(`/view-purchase-contract/${id}`)
  }

  const handleApprove = (data) => {
    let app = <ApproveModal data={data} handlerList={handlerPurchaseContractList} pageNumber={pageNumber} pageSize={pageSize} globalSearch={globalSearch} type={PURCHASE_CONTRACT_APPROVE_ID} />
    handleModalData(app, "md");
  }

  const handleReject = (data) => {
    let reject = <RejectionModal data={data} handlerPurchaseContractList={handlerPurchaseContractList} pageNumber={pageNumber} pageSize={pageSize} globalSearch={globalSearch} />
    handleModalData(reject, "md");
  }

  const handlerCreateInvoice = (data) => {
    if (data?.Difference === 0) {
      const alert = <Alert message={FULLY_PAID_MESSAGE} />
      handleModalData(alert, "md");
    }
    else if (data?.VendorStatus === VENDOR_MANAGER_PENDING && data?.IsSelfService === true) {
      let alert = <Alert message={PENDING_DETAILS_MESSAGE} />;
      handleModalData(alert, "md");
    }
    else {
      navigate(`/add-bill/${data.id}`);
    }
  };

  const handlerEditPurchaseContarct = (data) => {
    navigate(`/edit-executive-contract/${data.id}`)
  }

  const columns = useMemo(() => [
    {
      Header: PURCHASE_CONTRACT,
      accessor: "DocumentNo",
    },
    {
      Header: VENDOR_NAME,
      accessor: "LegalName",
    },
    {
      Header: START_DATE,
      accessor: "StartDate",
      Cell: ({ row }) => <>{useDateFormat(row.original.StartDate)}</>,
    },
    {
      Header: END_DATE,
      accessor: "EndDate",
      Cell: ({ row }) => <>{useDateFormat(row.original.EndDate)}</>,
    },
    {
      Header: <div className='ms-auto'>Contract Total</div>,
      accessor: "ContractTotal",
      Cell: ({ row }) => <><div className='text-end'>{row?.original?.CurrencySymbol} {row.original.ContractTotal?.toFixed(2)}</div></>,
    },
    {
      Header: <div className='m-auto'>Status</div>,
      accessor: "StatusName",
      Cell: ({ row }) => useStatusRenderer(row),
      disableSortBy: true,
    },
    {
      Header: "Action",
      accessor: (data) => <>
        <div className="d-flex align-item-center w-100">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips1">
                View
              </Tooltip>
            }
          >
            <img
              src={eyeIcon}
              alt=" "
              className="cursor-pointer cstm-eye-icon-gap"
              onClick={() => handlerPurchaseView(data.id)}
            />
          </OverlayTrigger>

          {(data.Status === VENDOR_APPROVE) && (user.RoleId !== SUPER_ADMIN_ID) && (user.RoleId !== VP_ID)
            && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips2">
                    Create Bill
                  </Tooltip>
                }
              >
                <img
                  src={invoiceIcon}
                  alt=""
                  className="cursor-pointer cstm-icon-gap"
                  onClick={() => handlerCreateInvoice(data)}
                />
              </OverlayTrigger>
            )}

          {((data.Status === VENDOR_MANAGER_PENDING &&
            user.RoleId === ADMIN_MANAGER_ID) ||
            (data.Status === VENDOR_VP_PENDING &&
              user.RoleId === VP_ID)) && (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips3">
                      Approve
                    </Tooltip>
                  }
                >
                  <span
                    className="cursor-pointer cstm-icon-gap"
                    onClick={() => handleApprove(data)}
                  >
                    <ApproveButton />
                  </span>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips4">
                      Reject
                    </Tooltip>
                  }
                >
                  <span
                    className="cursor-pointer cstm-icon-gap"
                    onClick={() => handleReject(data)}
                  >
                    <RejectButton />
                  </span>
                </OverlayTrigger>
              </>
            )}

          {(data.Status === VENDOR_REJECT ||
            (data.Status === VENDOR_MANAGER_PENDING &&
              user.RoleId === ADMIN_MANAGER_ID)) && (
              <>
                {(user.RoleId !== VP_ID) && (user.RoleId !== SUPER_ADMIN_ID) && (user.RoleId !== VENDORID) && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip className="custom-tooltip cstm-tooltip" id="tooltips5">
                        Edit
                      </Tooltip>
                    }
                  >
                    <img className="cursor-pointer cstm-icon-gap"
                      src={edit}
                      alt=""
                      onClick={() => handlerEditPurchaseContarct(data)}
                    />
                  </OverlayTrigger>
                )}
              </>
            )}
        </div>
      </>,
      disableSortBy: true,
    },
  ], [handlerPurchaseContractList, pageNumber, pageSize, globalSearch, user]);

  return columns;
};